import firebase from "firebase/app";
import { useEffect } from "react";
import uuid from "react-native-uuid";
import { useSelector } from "react-redux";
import { sendBotMessage } from "../messages/actions";
import { tReduxAction } from "../types";
import Bugsnag from "@bugsnag/js";
import { useAppDispatch } from "src/redux";

type tpUseErrorHandler = () => void;
export const useErrorHandler: tpUseErrorHandler = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch({
      type: "CLEAR_ERRORS",
    });
  }, [dispatch]);
};

export const useDisplayErrorRibbon = (): void => {
  const dispatch = useAppDispatch();
  const showRibbon = useSelector(({ ErrorHandlerReducer }) => ErrorHandlerReducer.showRibbon);

  useEffect(() => {
    if (showRibbon) {
      setTimeout(() => dispatch({ type: "RIBBON" }), 7000);
    }
  }, [dispatch, showRibbon]);
};

type tpHandleErrorEvent = (message: string, type: "error" | "success", errorMessage?: Error) => tReduxAction;
export const handleErrorEvents: tpHandleErrorEvent = (message, type, errorMessage) => (dispatch, getState) => {
  const kUuid = uuid.v4().toString();
  const aLastMessageDate = new Date();
  const s = getState();

  if (type === "error" && errorMessage) {
    dispatch({ type: "RIBBON", message: errorMessage });
    firebase
      .analytics()
      .logEvent(
        `Error: ${message}\n` +
          `${s.UserReducer.profile.firstName} ${s.UserReducer.profile.lastName} of ${s.UserReducer.profile.companyRefPath} had an error: ${errorMessage.message}`,
      );
    Bugsnag.notify(errorMessage);
  } else {
    dispatch({ type: "RIBBON", message: message });
    firebase
      .analytics()
      .logEvent(
        `Success: ${message}\n` +
          `${s.UserReducer.profile.firstName} ${s.UserReducer.profile.lastName} of ${s.UserReducer.profile.companyRefPath}`,
      );
    Bugsnag.notify(
      `Success: ${message}\n` +
        `${s.UserReducer.profile.firstName} ${s.UserReducer.profile.lastName} of ${s.UserReducer.profile.companyRefPath}`,
    );
    dispatch(
      sendBotMessage([
        {
          _id: kUuid,
          createdAt: aLastMessageDate,
          text: message,
          user: { _id: "tmt_brand" },
        },
      ]),
    );
  }
};
